module.exports = __webpack_public_path__ + "static/img/icon18.0b204c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon18.png
// module id = yrMT
// module chunks = 1